import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input } from '@driftt/tide-core'
import './style.css'


class ServiceTermsContent extends Component {
  static propTypes = {
    appId: PropTypes.string.isRequired,
    agreesToTermsOfService: PropTypes.bool,
    updateTermsOfServiceFlag: PropTypes.func.isRequired,
    updateSecurityReviewFlag: PropTypes.func.isRequired,
    showErrorNotification: PropTypes.func.isRequired
  }

  static defaultProps = {
    agreesToTermsOfService: false,
    agreesToSecurityReview: false
  }

  onUpdateTermsOfServiceFlag = (agreesToTermsOfService) => {
    const { updateTermsOfServiceFlag, showErrorNotification } = this.props

    updateTermsOfServiceFlag(agreesToTermsOfService)
      .catch(() => showErrorNotification('Oops, something went wrong. Please agree to the Terms of Service again.'))
  }

  render() {
    const { agreesToTermsOfService } = this.props

    return (
      <div className="app-submit-view-accordion-content">
        <div className="app-submit-view-accordion-terms">
          <Input
            className="service-terms-content-checkbox"
            type="checkbox"
            onChange={this.onUpdateTermsOfServiceFlag}
            checked={agreesToTermsOfService}
          />
          <p className="app-submit-view-accordion-terms-label" on>
            I agree to the <a href="https://www.drift.com/api-terms-of-service" target="_blank" rel="noopener noreferrer">Drift API Terms of Service</a>
          </p>
        </div>
      </div>
    )
  }
}

export default ServiceTermsContent
